import data from '@/assets/data'
import request from '@/utils/request'
let resquest = process.env.VUE_APP_BASE_API

export default {
  /* ---------------------------------长篇小说相关接口---------------------------- */
  //创建小说、编辑小说 初始化自定义动态的表单参数
  initLongNovelFromParams(params) {
    return request({
      url: `${resquest}/novel/public/lnovel/setting`,
      method: 'get',
      params: params
    })
  },
  //添加长篇小说
  longNovelAdd(data) {
    return request({
      url: `${resquest}/novel/app/lnovel/create`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data
    })
  },
  //长篇小说列表
  longNovelList(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/list`,
      method: 'get',
      params: params
    })
  },
  //长篇小说详情
  longNovelDetail(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/details`,
      method: 'get',
      params: params
    })
  },
  //长篇小说成功后ai帮写生成的接口，需要传id --2025年6月27号 新接口
  longNovelHelpWriteId(type, params) {
    return request({
      url: `${resquest}/novel/app/writer/lnovel/async/${type}`,
      method: 'post',
      data: params
    })
  },
  //长篇分卷列表
  seriesList(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/series/list`,
      method: 'get',
      params: params
    })
  },
  //长篇分卷列表分页
  seriesListV2(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/series/list/v2`,
      method: 'get',
      params: params
    })
  },
  //保存分卷
  seriesInsert(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/series/insert`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: params
    })
  },
  //分卷详情
  seriesDetail(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/series/details`,
      method: 'get',
      params: params
    })
  },
  //修改分卷
  seriesUpdate(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/series/update`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: params
    })
  },
  //删除分卷
  seriesDel(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/series/delete`,
      method: 'post',
      params: params
    })
  },
  //长篇-保存大纲
  longChaptersInsert(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/chapters/insert`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: params
    })
  },
  //长篇-章节列表
  longChapterList(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/chapter/list`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'get',
      params: params
    })
  },
  //长篇-章节详情
  longChapterDetail(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/chapter/details`,
      method: 'get',
      params: params
    })
  },
  //长篇-保存章纲
  longChapterOverviewSave(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/chapter/overview`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: params
    })
  },
  //长篇-保存正文
  longChapterTextSave(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/chapter/save`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: params
    })
  },
  //长篇-当前分卷
  currSeries(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/series/curr`,
      method: 'get',
      params: params
    })
  },
  //长篇-当前章节
  currChapter(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/chapter/curr`,
      method: 'get',
      params: params
    })
  },
  //长篇-获取上一章
  findChapter(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/chapter/find`,
      method: 'get',
      params: params
    })
  },
  //长篇-追加分卷
  appendSeries(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/series/append`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: params
    })
  },
  //长篇-修改分卷
  longNovelUpdate(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/update`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: params
    })
  },
  //长篇-修改大纲
  longChapterOutlineUpdate(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/chapter/outline`,
      method: 'post',
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      data: params
    })
  },
  //长篇-修改封面
  longNovelCoverUpdate(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/cover`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: params
    })
  },
  //长篇-删除小说
  longNovelDel(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/delete`,
      method: 'post',
      data: params
    })
  },
  //长篇-小说置顶
  longNovelDel1(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/delete`,
      method: 'post',
      data: params
    })
  },
  //长篇-下载小说
  longNovelDown(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/dwonload`,
      method: 'get',
      params: params
    })
  },
  //长篇-清空章节大纲
  delChapter(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/chapter/clear`,
      method: 'post',
      data: params
    })
  },
  //长篇-导入章节
  longChapterImport(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/chapters/import`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: params
    })
  },
  //长篇-导入分卷
  longSeriesImport(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/series/import`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: params
    })
  },
  //长篇-下载小说
  longNovelDownload(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/download`,
      method: 'get',
      params: params
    })
  },
  //长篇-小说置顶
  longNovelTop(params) {
    return request({
      url: `${resquest}/novel/app/lnovel/top`,
      // headers: {
      //   "Content-Type": 'application/json;charset=utf-8'
      // },
      method: 'post',
      params: params
    })
  },
  //长篇-篇幅文案
  longNovelDown(params) {
    return request({
      url: `${resquest}/novel/public/novel/copywriting`,
      method: 'get',
      params: params
    })
  },
  //长篇-修改大纲（批量）
  longNovelEditor(data) {
    return request({
      url: `${resquest}/novel/app/lnovel/chapters/save`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data: data
    })
  },
}